import React from "react";
import { Sidebar, SidebarProps } from "primereact/sidebar";
import styles from "../../property-list/map-box/map-box.module.scss";
import PrePinsToggle from "../pre-pins-toggle";

type ControlledSidebarProps = Omit<SidebarProps, "visible" | "onHide">;

export interface MapSidebarProps extends ControlledSidebarProps {
  showSidebar: boolean;
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>;
  showPre: boolean;
  setShowPre: React.Dispatch<React.SetStateAction<boolean>>;
}

const MapPrePinSidebar: React.FC<MapSidebarProps> = ({
  showSidebar,
  setShowSidebar,
  showPre,
  setShowPre,
  ...sidebarProps
}) => {
  
  const handleHide = () => {
    setShowSidebar(false);
    setShowPre(false);
  };

  return (
    <Sidebar
      visible={showSidebar}
      onHide={handleHide}
      position="bottom"
      showCloseIcon={false}
      className={styles.prePinsMobileSidebar}
      maskClassName={styles.prePinsMobileSidebarMask}
      {...sidebarProps}
      header={
        <div className={styles.prePinsSidebarHeader}>
          <span className={styles.prePinsSidebarTitle}>PRE Pins</span>
          <img
            src="/images/close.png"
            alt="Close"
            className={styles.prePinsSidebarClose}
            onClick={() => handleHide()}
          />
        </div>
      }
    >
      <PrePinsToggle
        showPre={showPre}
        onToggle={setShowPre}
        mobileVariant
        alwaysShowLegend
        onApply={() => setShowSidebar(false)}
      />
    </Sidebar>
  );
};

export default MapPrePinSidebar;
